import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import {
  StyledUnmappedVariablColumnLabel,
  StyledUnmappedVariableGroupLabel,
} from './styles';
import Subsection from '__components/Modals/Common/Subsection';
import {
  type UnmappedVariableOption,
  type UnmappedVariableWithFields,
} from './helpers';
import { UnmappedVariableRow } from './UnmappedVariableRow';
import Cols from '__components/Layout/Cols';

type UnmappedVariablesProps = {
  unmappedVariables: { label: string; options: UnmappedVariableWithFields[] }[];
  onChange: (fieldForMapping: UnmappedVariableOption) => void;
};

export const UnmappedVariables: FC<UnmappedVariablesProps> = ({
  unmappedVariables,
  onChange,
}) => {
  const { t } = useTranslation();

  const hasTwoColumns = unmappedVariables.some(
    ({ options }) => options.length > 1
  );

  return (
    <Subsection title={t('Unmapped Variables')}>
      <Cols columns={2} gutter="60px">
        {Array.from({ length: hasTwoColumns ? 2 : 1 }, (_, i) => (
          <Cols columns={2} gutter="20px" key={i}>
            {[t('Variable Name'), t('Kizen Fields for Mapping')].map(
              (label, j) =>
                label ? (
                  <StyledUnmappedVariablColumnLabel key={j} weight="bold">
                    {label}
                  </StyledUnmappedVariablColumnLabel>
                ) : null
            )}
          </Cols>
        ))}
      </Cols>
      {unmappedVariables.map(({ label, options }) => {
        return (
          <div key={label}>
            <Subsection>
              <StyledUnmappedVariableGroupLabel
                weight="bold"
                color="var(--color-font-placeholder)"
              >
                {label}
              </StyledUnmappedVariableGroupLabel>
              <Cols columns={2} gutter="60px">
                {options.map(({ variable, fieldsForMapping }) => {
                  return (
                    <UnmappedVariableRow
                      key={variable.id}
                      variable={variable}
                      fieldsForMapping={fieldsForMapping}
                      onChange={onChange}
                    />
                  );
                })}
              </Cols>
            </Subsection>
          </div>
        );
      })}
    </Subsection>
  );
};
